import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { GitBranch, FileText, ShoppingBag, Wand2, Megaphone, Mail, LayoutTemplate } from "lucide-react";
import { SectionHeader } from "./Capture";

import FunnelLab from "../forge/FunnelLab";
import ContentLab from "../forge/ContentLab";
import OfferLab from "../forge/OfferLab";
import SalesCopy from "../forge/SalesCopy";
import AdCreative from "../forge/AdCreative";
import EmailCampaigns from "../forge/EmailCampaigns";
import LandingPagesPanel from "../forge/LandingPagesPanel";
import ForgeUsage from "../forge/ForgeUsage";

const TABS = [
  { id: "funnels", label: "Funnel Lab",      icon: GitBranch,      comp: FunnelLab,           hint: "Visual chains: drag steps to reorder" },
  { id: "landing", label: "Landing Pages",   icon: LayoutTemplate, comp: LandingPagesPanel,   hint: "AI-generate + drag-edit sections · publish" },
  { id: "content", label: "Content Lab",     icon: FileText,       comp: ContentLab,          hint: "Hooks · captions · CTAs · variations" },
  { id: "offers",  label: "Offer Lab",       icon: ShoppingBag,    comp: OfferLab,            hint: "Pricing · bonus stack · positioning · score" },
  { id: "sales",   label: "Sales Copy",      icon: Wand2,          comp: SalesCopy,           hint: "Landing · VSL · email sales · variations" },
  { id: "ads",     label: "Ad Creative",     icon: Megaphone,      comp: AdCreative,          hint: "Hooks · angles · UGC · thumbnails" },
  { id: "emails",  label: "Email Campaigns", icon: Mail,           comp: EmailCampaigns,      hint: "Lifecycle sequences · timeline view" },
];

export default function Forge() {
  const [params, setParams] = useSearchParams();
  const initial = params.get("tab") || "funnels";
  const [tab, setTab] = useState(initial);
  const Active = TABS.find(t => t.id === tab)?.comp || FunnelLab;
  const meta = TABS.find(t => t.id === tab);

  return (
    <div data-testid="forge-page">
      <SectionHeader title="Forge" subtitle="Create the assets that compound revenue" tabs={TABS} active={tab}
        onChange={(id) => { setTab(id); setParams({ tab: id }); }} hint={meta?.hint} />
      <ForgeUsage />
      <Active />
    </div>
  );
}
